import Head from 'next/head'

const DefaultViewport = () => {
  return (
    <Head>
      <meta
        name="viewport"
        content="width=device-width,minimum-scale=1,initial-scale=1,maximum-scale=1,user-scalable=no"
      />
    </Head>
  )
}

export default DefaultViewport
